export enum DashboardNavRoute {
  DASHBOARD = '/weight-loss/dashboard',
  LEARN = '/weight-loss/learn',
  FAQ = '/weight-loss/faq',
}
